/**
 * Settings → Booking & arrival windows (docs/scheduling/scheduling-v2-ux.md §1).
 * Registered in the settings nav under Operations; gated on scheduling_policy:view.
 */
import { createFileRoute } from '@tanstack/react-router';
import { BookingWindowsSettingsPage } from '@/components/organisms/settings-booking-windows/BookingWindowsSettingsPage';

export const Route = createFileRoute('/_dashboard/dashboard/settings/booking-windows')({
  component: BookingWindowsSettingsPage,
});
